/**
 * Apollo website tracker — loaded ONLY after Analytics cookie consent.
 *
 * The script is never injected before consent (Garante / ePrivacy aligned),
 * mirroring the Sentry consent gate. Apollo exposes no clean teardown API, so
 * revoking consent after load prevents future re-init but cannot fully unload
 * an already-running third-party tracker without a page reload.
 */
const APOLLO_APP_ID = '6a38e5610dd7c1000cdbfb98';

let apolloLoaded = false;

export function isApolloLoaded(): boolean {
  return apolloLoaded;
}

export function loadApolloIfAnalyticsAllowed(analyticsEnabled: boolean): void {
  if (!analyticsEnabled || apolloLoaded) return;
  if (typeof document === 'undefined') return;

  apolloLoaded = true;
  const nocache = Math.random().toString(36).substring(7);
  const script = document.createElement('script');
  script.src = `https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=${nocache}`;
  script.async = true;
  script.defer = true;
  script.onload = () => {
    const w = window as unknown as {
      trackingFunctions?: { onLoad: (opts: { appId: string }) => void };
    };
    w.trackingFunctions?.onLoad({ appId: APOLLO_APP_ID });
  };
  document.head.appendChild(script);
}
